import * as React from 'react';
import * as _ from 'lodash';
import { format } from "date-fns"
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { RootState } from 'store/types';
import { editLiveDealerLMInfo, getDealerLMAPI, postDealerLMAPI } from './state/actions';
import { SectionWrapper } from 'common/baseComponents';
import { ReactComponent as IconDescription } from 'common/images/icon-description.svg'
import { ReactComponent as IconLink } from 'common/images/icon-link.svg'
import { ReactComponent as IconMail } from 'common/images/icon-mail.svg'
import { ReactComponent as IconOffice } from 'common/images/icon-office.svg'
import { ReactComponent as IconPhone } from 'common/images/icon-phone.svg'
import { ReactComponent as IconBusName } from 'common/images/icon-busname.svg'
import { GeneralContainer, Title, IconContainer, InputTextarea, ViewLabel, Input, UrlSectionContainer, DateFieldWrapper, PhoneMainContainer, PhoneSourceSubtitle, PhoneCheckboxLabel , FormatsAbsoluteContainer, FormatsContainer, FormatLabel, PhoneContainer, PhoneNumber, PhoneSource, AddressCustomContainer, AddressInput, AddressSelect } from './styles';
import { BodyContainer, ViewLabelUrl } from './styles';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { DatePicker } from 'components/DatePicker';
import { serviceLoading } from 'common/loaderReducer';
import { GET_DEALERLM_API_REQUEST } from 'features/Dealers/Listings/Data/state/actionTypes';
import { GET_DEALERINFO_API_REQUEST } from 'features/Dealers/Listings/Info/state/actionTypes';
import { POST_DEALERLM_API_REQUEST } from './state/actionTypes';
import Loader from 'components/Loader';
import { parseStringDateToDate, splitUrlComponents, getUtmParams } from 'features/Dealers/Listings/Data/state/utils';
import { SIZE } from 'common/sizes';
import { parseISO } from 'date-fns/esm';
import { CheckBoxComponent } from 'components/CheckBox';
import { LMAddress, LMconfig, PhoneSourceNumber } from 'features/Dealers/Listings/Data/state/types';
import InputPhone from 'components/InputPhone';
import TooltTip from 'components/ToolTip'
import { ReactComponent as IconInfo } from 'common/images/icon-info.svg'
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';
import { getSyncError } from 'features/Dealers/Listings/utils'
import PhoneSelect from 'features/Dealers/Listings/Data/PhoneSelect';
import { retry } from 'redux-saga/effects';
import { updateSelectedDealer } from 'features/Dealers/DealerSelect/state/actions';
import LMCategories from 'features/Dealers/Listings/Categories';
import Images from 'features/Dealers/Listings/Images';
import SpecialHours from 'features/Dealers/Listings/SpecialHours';
import Keywords from 'features/Dealers/Listings/Keywords';
import GoogleSpecific from 'features/Dealers/Listings/GoogleSpecific';
import FacebookSpecifics from 'features/Dealers/Listings/FacebookSpecifics';
import BingSpecifics from 'features/Dealers/Listings/BingSpecifics';
import { getLMValidationAPI } from 'features/Dealers/Listings/state/actions';
import {useLocation } from 'react-router-dom';
import OperationHours from 'features/Dealers/Listings/OperationHours';
import { ReactComponent as IconLocation } from 'common/images/icon-location.svg'
import ComboBox from 'components/ComboBox';
import { lookupService } from 'dns';
import ToolTip from 'components/ToolTip';
import TextToolTip from 'components/TextToolTip';

const DealerLM = () => {
    const [editingFields, setEditingFields] = React.useState<string[]>([])
    const [firstLoad, setFirstLoad] = React.useState(true)
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    
    const {
        websiteProvider,
        live,
        validation,
        originalLMDealerInfo,
        cmsInfo,
        isLoading,
        loadingFields,
        fieldDefaults,
        listingSyncErrors,
        isSaving,
        isRequestingCMS,
        selectedDealerId,
        selectedListingId,
        dealerPhones,
        gmbphone,
        locationName,
        websiteGBP,
        streetGBP,
        cityGBP,
        stateGBP,
        zipcodeGBP,
        countryGBP,
        selectedDealer,
        descriptionMinCharacters,
        descriptionMaxCharacters,
        user,
        countries,
        countryData
    } = useSelector((rootState: RootState) => {
        return {
            websiteProvider: rootState.dealers.dealer.websiteProvider,
            live: rootState.dealers.listing.currentListing.data.liveDealerLMInfo,
            validation: rootState.dealers.listing.currentListing.data.validation,
            cmsInfo: rootState.dealers.listing.currentListing.info.info,
            originalLMDealerInfo: rootState.dealers.listing.currentListing.data.dealerLMInfo,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            isLoading: serviceLoading(rootState, [GET_DEALERLM_API_REQUEST]),
            loadingFields: rootState.dealers.listing.currentListing.data.loadingFields,
            listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
            isSaving: serviceLoading(rootState, [POST_DEALERLM_API_REQUEST]),
            isRequestingCMS: serviceLoading(rootState, [GET_DEALERINFO_API_REQUEST]),
            fieldDefaults: rootState.dealers.listing.currentListing.data.fieldDefaults,
            //dealerPhones: rootState.dealers.dealer.selectedDealer?.phoneNumbers,
            dealerPhones: rootState.dealers.dealer.phoneNumbers,
            gmbphone: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.phone,
            locationName: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.name,
            websiteGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.website,
            streetGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.street,
            cityGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.city,
            stateGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.state,
            zipcodeGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.zipcode,
            countryGBP: rootState.dealers.listing.currentListing.enginePreview.gmbPreview?.country,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            descriptionMinCharacters: rootState.dealers.listing.listings.lmValidation?.descriptionValidation?.minCharacters,
            descriptionMaxCharacters: rootState.dealers.listing.listings.lmValidation?.descriptionValidation?.maxCharacters,
            user:rootState.security.user,
            countries: rootState.dealers.enginedealer.countries,
            countryData: rootState.dealers.enginedealer.countryData
        } 
    }, shallowEqual);



    
    React.useEffect(() => {
        if (!isRequestingCMS && live) {            
            const cmsPhone = cmsInfo?.phone ?? ""
            const csmBusinessName = cmsInfo?.name??"";
            const cmsWebsite = cmsInfo?.url??""
           

            if (live?.phoneType == undefined || live.phoneType == null || live.phoneType=="" || live.businessNameType=="" || live.businessNameType=="" || live.businessNameType==null || live.urlWebsiteType=="" || live.urlWebsiteType==undefined || live.urlWebsiteType==null)
            {             
                
                let liveDelta: Partial<LMconfig> = {};
                if (live?.phoneType == undefined || live.phoneType == null || live.phoneType==""){
                    liveDelta = {
                        phoneType: live.isPhoneDefaultFromCMS?"GMB":"Custom", 
                        phone: live.isPhoneDefaultFromCMS?cmsPhone:live.phone ,
                    }
                }
                if (live.businessNameType==undefined || live.businessNameType=="" || live.businessNameType==null)
                {
                    liveDelta = {
                        ...liveDelta,
                        businessName: (live.businessName??"")==""?csmBusinessName:live.businessName,
                        businessNameType:(live.businessNameType??"")==""?"CMS":live.businessNameType
                    }
                }
                if (live.urlWebsiteType==undefined || live.urlWebsiteType=="" || live.urlWebsiteType==null)
                {
                    liveDelta = {
                        ...liveDelta,
                        urlWebsite: (live.urlWebsite??"")==""?cmsWebsite:live.urlWebsite,
                        urlWebsiteType:(live.urlWebsiteType??"")==""?"CMS":live.urlWebsiteType
                    }
                }


                dispatch(editLiveDealerLMInfo({ ...live,...liveDelta}))                         
                if (originalLMDealerInfo)
                {       
                    const editedLMConfig = {
                        ...originalLMDealerInfo,                    
                        ...liveDelta
                    }
                    dispatch(postDealerLMAPI(selectedListingId ?? "", "", editedLMConfig))
                }
            }



        }
    }, [isRequestingCMS])


    const phoneArray = React.useMemo(() => {
        
        if (dealerPhones) {            
            const phoneArrayCMS= dealerPhones.map(dealerPhoneNumber => ({
                number: dealerPhoneNumber.phone,
                source: (dealerPhoneNumber.type =="" || dealerPhoneNumber.type ==undefined? "Phone number": dealerPhoneNumber.type) + " (CMS)"
            }))
            const phoneArray: PhoneSourceNumber[] = []
            let gmboption : PhoneSourceNumber = 
            {
                number: gmbphone?gmbphone:"",
                source: "GMB"
            }
            phoneArray.push(gmboption)
            let customoption : PhoneSourceNumber = 
            {
                number: "",
                source: "Custom"
            }
            phoneArray.push(customoption)                       
            return phoneArray.concat(phoneArrayCMS);
        }
        return undefined;
    }, [selectedDealerId, gmbphone, dealerPhones])


    const namesArray = React.useMemo(() => {
        if (selectedDealer) {            
          const array: PhoneSourceNumber[] = []
          let cmsoption : PhoneSourceNumber = 
          {
              number: selectedDealer.name,
              source: "CMS"
          }
          array.push(cmsoption)
            let gmboption : PhoneSourceNumber = 
            {
                number: locationName??"",
                source: "Google Business Profile"
            }
            array.push(gmboption)
            let customoption : PhoneSourceNumber = 
            {
                number: "",
                source: "Custom"
            }
            array.push(customoption)                       
            return array;
        }
        return undefined;
    }, [selectedDealerId, locationName])

    const websitesArray = React.useMemo(() => {
        if (selectedDealer) {            
          const array: PhoneSourceNumber[] = []
          let cmsoption : PhoneSourceNumber = 
          {
              number: selectedDealer.url??"",
              source: "CMS"
          }
          array.push(cmsoption)
            let gmboption : PhoneSourceNumber = 
            {
                number: websiteGBP??"",
                source: "GBP"
            }
            array.push(gmboption)
            let customoption : PhoneSourceNumber = 
            {
                number: "",
                source: "Custom"
            }
            array.push(customoption)                       
            return array;
        }
        return undefined;
    }, [selectedDealerId, websiteGBP])

    const operationHoursTypeArray = React.useMemo(() => {
        if (selectedDealer) {            
          const array: PhoneSourceNumber[] = []
          let cmsoption : PhoneSourceNumber = 
          {
              number: selectedDealer.url??"",
              source: "CMS"
          }
          array.push(cmsoption)
            let gmboption : PhoneSourceNumber = 
            {
                number: websiteGBP??"",
                source: "GBP"
            }
            array.push(gmboption)
            let customoption : PhoneSourceNumber = 
            {
                number: "",
                source: "Custom"
            }
            array.push(customoption)                       
            return array;
        }
        return undefined;
    }, [selectedDealerId, websiteGBP])

    const addressArray = React.useMemo(() => {
        if (selectedDealer) {            
          const array: PhoneSourceNumber[] = []
          let cmsoption : PhoneSourceNumber = 
          {
              number: cmsInfo?.adress??"",
              source: "CMS"
          }
          array.push(cmsoption)
            let gmboption : PhoneSourceNumber = 
            {
                number: streetGBP??"",
                source: "GBP"
            }
            array.push(gmboption)
            let customoption : PhoneSourceNumber = 
            {
                number: "",
                source: "Custom"
            }
            array.push(customoption)                       
            return array;
        }
        return undefined;
    }, [selectedDealerId, streetGBP, cmsInfo])

    const countryArray = React.useMemo(() => {

        return countries?.map((item, index)=>{
            return item.name // name-> United States iso2 -> US iso3 -> USA
        })
    }, [countries])

    const stateArray = React.useMemo(() => {

        if (live?.address && live.address.country )
        {
            let country = countries?.find(f=>f.iso2== live?.address.country)
            return country?.states?.map((item, index)=>{
                return item.name
            })
        }
    }, [ live?.address && live.address.country])

    React.useEffect(() => {
        if (selectedListingId && selectedListingId != "") {
            dispatch(getDealerLMAPI(selectedListingId))
            if (selectedDealerId)
                dispatch(updateSelectedDealer(selectedDealerId))
        }
    }, [selectedListingId])

    
    React.useEffect(() => {
        if (descriptionMinCharacters === undefined || descriptionMaxCharacters === undefined) {
            dispatch(getLMValidationAPI());
        }
    }, []) 


    React.useEffect(() => {
        if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId) {
            dispatch(getListingSyncErrors(selectedListingId??""));
            dispatch(getDealerListingsWithErrors(selectedDealerId??""));
        }
        setFirstLoad(false);
    }, [isSaving]) 

    React.useEffect(() => {
        if (validation && !validation.allDataValid && validation.dataValidation) {
            if(validation.dataValidation.appointmentUrlError && validation.dataValidation.appointmentUrlError!="")
            {
                setEditingFields([...editingFields, 'urlAppointment']);
            } 
            if(validation.dataValidation.menuUrlError && validation.dataValidation.menuUrlError!="")
            {
                setEditingFields([...editingFields, 'urlMenu']);
            } 
            if(validation.dataValidation.placeOrderLinkError && validation.dataValidation.placeOrderLinkError!="")
            {
                setEditingFields([...editingFields, 'urlOrder']);
            } 
            if(validation.dataValidation.websiteUrlError && validation.dataValidation.websiteUrlError!="")
            {
                setEditingFields([...editingFields, 'urlWebsite']);
            } 
        }
        setFirstLoad(false);
    }, [validation]) 

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return <Loader />
    }

    const { url, queryStringParameter } = splitUrlComponents(live ? live["urlGeneric"] : "", "urlGeneric", fieldDefaults)

    return (
        <GeneralContainer>

            <Title>
                As configured in Listings Manager
                <IconContainer>
                    <IconInfo />
                    <FormatsAbsoluteContainer>
                        <FormatsContainer>
                            <FormatLabel >
                                {
                                    `Listings Manager will append ${websiteProvider?.displayName ?? 'DealerOn'}'s UTM parameters to any links. The parameters are:` + getUtmParams(selectedDealer?.lmPackage??'', location.pathname , fieldDefaults)
                                }
                            </FormatLabel>
                        </FormatsContainer>
                    </FormatsAbsoluteContainer>  
                </IconContainer>
                
            </Title>

            <BodyContainer>
            {
                selectedDealer && selectedDealer.lmPackage == "ELITE" && location.pathname.includes("primary") &&
                <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                    <InputIconField
                        label={'Business Name'}
                        state={getStateForField('businessName')}
                        renderValue={renderBusinessName}
                        renderIcon={() => { return (<IconContainer><IconBusName /></IconContainer>) }}                     
                        onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'businessName') }}
                        disabled={getIsFieldDisabled("businessName")}
                        disableSave={(live?.businessNameType=="Custom" && live?.businessName=="")}                        
                        disableBackground={true}
                    />
                </SectionWrapper>
            }
             {
               selectedDealer && (selectedDealer.siteType == "Proxy" || selectedDealer.siteType == "DealerOnLite") &&
                <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                    <InputIconField
                        label={'Address'}
                        state={getStateForField('address')}
                        renderValue={renderAddress}
                        renderIcon={() => { return (<IconContainer><IconLocation /></IconContainer>) }}                     
                         showAlertIcon={getSyncError('address',listingSyncErrors)?true:false}
                        alertToolTip={getSyncError('address',listingSyncErrors)}
                        showEditErrorMessage={getSyncError('address',listingSyncErrors)?true:false}
                        editErrorMessage={getSyncError('address',listingSyncErrors)}
                        onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'address') }}
                        disabled={getIsFieldDisabled("address")}
                        disableSave={(live?.addressType=="Custom" && !live?.address)}                        
                        disableBackground={true}
                    />
                </SectionWrapper>
            }
           
                <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                    <InputIconField
                        label={'Phone'}
                        state={getStateForField('phone')}
                        renderValue={renderPhone}
                        renderIcon={() => { return (<IconContainer><IconPhone /></IconContainer>) }}
                        showAlertIcon={getSyncError('phoneNumbers',listingSyncErrors)?true:false}
                        alertToolTip={getSyncError('phoneNumbers',listingSyncErrors)}
                        showEditErrorMessage={getSyncError('phoneNumbers',listingSyncErrors)?true:false}
                        editErrorMessage={getSyncError('phoneNumbers',listingSyncErrors)}
                        onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'phone') }}
                        disabled={getIsFieldDisabled("phone")}
                        disableSave={(live?.phoneType=="Custom" && live?.phone=="")}
                        //disabled={getIsFieldDisabled("phone")}
                        disableBackground={true}
                    />
                </SectionWrapper>

           
            <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Description'}
                    state={getStateForField('description')}
                    renderValue={renderDescription}
                    renderIcon={() => { return (<IconContainer><IconDescription /></IconContainer>) }}
                    showAlertIcon={getSyncError('profile',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('profile',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('profile',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('profile',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'description') }}
                    disabled={getIsFieldDisabled("description")}
                    showCharacterCount={true}
                    showCharacterLimit={true}
                    minCharacters={descriptionMinCharacters}
                    maxCharacters={descriptionMaxCharacters}
                    characterCount={getCharacterCount('description')}
                />
            </SectionWrapper>
            {
                selectedDealer && (selectedDealer.siteType == "Proxy" || selectedDealer.siteType == "DealerOnLite") &&
                <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                    <InputIconField
                        label={'Website URL'}
                        renderValue={(state) => renderURLTyped('urlWebsite')}
                        state={getStateForField('urlWebsite')}
                        renderIcon={() => { return (<IconContainer><IconLink /></IconContainer>) }}
                        showAlertIcon={getSyncError('customAttributes.url_website',listingSyncErrors)?true:false}
                        alertToolTip={getSyncError('customAttributes.url_website',listingSyncErrors)}
                        showEditErrorMessage={getEditError('urlWebsite','customAttributes.url_website')?true:false}
                        editErrorMessage={getEditError('urlWebsite','customAttributes.url_website')}
                        onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'urlWebsite') }}
                        disabled={getIsFieldDisabled("urlWebsite")}                     
                        disableSave={(live?.urlWebsiteType=="Custom" && live?.urlWebsite=="")}                        
                        disableBackground={true}
                    />
                </SectionWrapper>
            }
            <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Appointment URL'}
                    renderValue={(state) => renderURL('urlAppointment')}
                    state={getStateForField('urlAppointment')}
                    renderIcon={() => { return (<IconContainer><IconLink /></IconContainer>) }}
                    showAlertIcon={getSyncError('customAttributes.url_appointment',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('customAttributes.url_appointment',listingSyncErrors)}
                    showEditErrorMessage={getEditError('urlAppointment','customAttributes.url_appointment')?true:false}
                    editErrorMessage={getEditError('urlAppointment','customAttributes.url_appointment')}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'urlAppointment') }}
                    disabled={getIsFieldDisabled("urlAppointment")}
                />
            </SectionWrapper>

            <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Menu URL'}
                    renderValue={(state) => renderURL('urlMenu')}
                    state={getStateForField('urlMenu')}
                    renderIcon={() => { return (<IconContainer><IconLink /></IconContainer>) }}
                    showAlertIcon={getSyncError('customAttributes.url_menu',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('customAttributes.url_menu',listingSyncErrors)}
                    showEditErrorMessage={getEditError('urlMenu','customAttributes.url_menu')?true:false}
                    editErrorMessage={getEditError('urlMenu','customAttributes.url_menu')}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'urlMenu') }}
                    disabled={getIsFieldDisabled("urlMenu")}
                />
            </SectionWrapper>

            <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Place an Order Link'}
                    renderValue={(state) => renderURL('urlOrder')}
                    state={getStateForField('urlOrder')}
                    renderIcon={() => { return (<IconContainer><IconLink /></IconContainer>) }}
                    showAlertIcon={getSyncError('customAttributes.url_shop_online',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('customAttributes.url_shop_online',listingSyncErrors)}
                    showEditErrorMessage={getEditError('urlOrder','customAttributes.url_shop_online')?true:false}
                    editErrorMessage={getEditError('urlOrder','customAttributes.url_shop_online')}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'urlOrder') }}
                    disabled={getIsFieldDisabled("urlOrder")}
                />
            </SectionWrapper>

            <SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Date First Opened'}
                    renderValue={(state) => renderDate()}
                    state={getStateForField('dateFirstOpened')}
                    renderIcon={() => { return (<IconContainer><IconOffice /></IconContainer>) }}
                    showAlertIcon={getSyncError('openInfo.date',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('openInfo.date',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('openInfo.date',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('openInfo.date',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action, 'dateFirstOpened') }}
                    disabled={getIsFieldDisabled("dateFirstOpened")}
                    disableBackground={true}
                />
            </SectionWrapper>

            <LMCategories />
            <Images />
            {selectedDealer && (selectedDealer.siteType == "Proxy" || selectedDealer.siteType == "DealerOnLite") && <OperationHours operationTypesArray={operationHoursTypeArray??[]}></OperationHours>}
            <SpecialHours />
            {(selectedDealer && selectedDealer.lmPackage == "ELITE" && location.pathname.includes("primary")) && <Keywords />}

            {(selectedDealer && selectedDealer.lmPackage == "ELITE" && location.pathname.includes("primary")) && <>
                <GoogleSpecific/>
                <FacebookSpecifics/>
                <BingSpecifics/>
            </>}
            </BodyContainer>

        </GeneralContainer>
    )

    function getValidationError(field: string)
    {
        if(field=='urlAppointment' && validation && validation.dataValidation && validation.dataValidation.appointmentUrlError && validation.dataValidation.appointmentUrlError!="")
        {
            return validation.dataValidation.appointmentUrlError;
        }
        if(field=='urlMenu' && validation && validation.dataValidation && validation.dataValidation.menuUrlError && validation.dataValidation.menuUrlError!="")
        {
            return validation.dataValidation.menuUrlError;
        }
        if(field=='urlOrder' && validation && validation.dataValidation && validation.dataValidation.placeOrderLinkError && validation.dataValidation.placeOrderLinkError!="")
        {
            return validation.dataValidation.placeOrderLinkError;
        }
        if(field=='urlWebsite' && validation && validation.dataValidation && validation.dataValidation.websiteUrlError && validation.dataValidation.websiteUrlError!="")
        {
            return validation.dataValidation.websiteUrlError;
        }
        return undefined;
    }

    function getEditError(fieldValidationError: string, fieldSyncErrors: string)
    {
        const validationError = getValidationError(fieldValidationError);
        if(validationError)
        {
            return validationError;
        }
        else
        {
            return getSyncError(fieldSyncErrors,listingSyncErrors);
        }
    }

    function getStateForField(field: string) {
        if (editingFields.indexOf(field) !== -1) {
            return InputIconFieldState.EDIT;
        } else if (loadingFields && loadingFields[field]) {
            return InputIconFieldState.LOADING
        } else {
            return InputIconFieldState.VIEW
        }
    }

    function getIsFieldDisabled(field: string) {
        if (loadingFields && Object.keys(loadingFields).length > 0 && !loadingFields[field]) {
            return true
        }
        return undefined;
    }

    function renderDate() {
        const isEditing = editingFields.indexOf('dateFirstOpened') !== -1;
        if (isEditing) {
            return (
                <DateFieldWrapper>
                    <DatePicker
                        value={live?.dateFirstOpened}
                        onChange={(date) => { onDealerInfoChange('dateFirstOpened', date) }}
                    />
                </DateFieldWrapper>
            )
        } else {
            const dateFormatted = parseStringDateToDate(live?.dateFirstOpened)
            return (
                <DateFieldWrapper>
                    <ViewLabel>
                        {
                            dateFormatted
                        }
                    </ViewLabel>
                </DateFieldWrapper>
            )
        }
    }

    function renderDescription() {
        const isEditing = editingFields.indexOf('description') !== -1;
        if (!isEditing) {
            if (_.isEmpty(live?.description)) {
                return null
            } else {
                return (
                    <ViewLabel>
                        {
                            live?.description
                        }
                    </ViewLabel>)
            }

        } else {
            return (
                <InputTextarea
                    value={live?.description}
                    onChange={(e) => (!descriptionMaxCharacters || e.target.value.length<=descriptionMaxCharacters) ? (onDealerInfoChange('description', e.target.value)) : (onDealerInfoChange('description', e.target.value.substring(0,descriptionMaxCharacters)))}
                />
            )
        }
    }

    function renderURL(field: string) {
        const { url, queryStringParameter } = splitUrlComponents(live ? live[field] : "", field, fieldDefaults)
        return (
            <UrlSectionContainer>
                {
                    editingFields.indexOf(field) === -1
                        ?
                        <ViewLabelUrl>
                            {
                                url
                            }
                        </ViewLabelUrl>
                        :
                        <Input
                            value={url}
                            onChange={(e) => onDealerInfoChange(field, `${e.target.value}${queryStringParameter}`)}
                        />
                }
            </UrlSectionContainer>
        )
    }

    function renderURLTyped(field: string) {
        const { url, queryStringParameter } = splitUrlComponents(live ? live[field] : "", field, fieldDefaults)
        const isEditing = editingFields.indexOf(field) !== -1;
        return (

            <UrlSectionContainer>
            {
                isEditing ?
                    <>
                        {
                            live?.urlWebsiteType =="Custom" ?
                            <InputPhone
                                value={live?.urlWebsite}                                
                                onChange={(value) => onDealerInfoChange(field, `${value}${queryStringParameter}`)}
                                type={"1"}
                                style={{width: '284px'}}
                            />
                            :
                            <PhoneContainer> {url}</PhoneContainer>
                        }
                         <PhoneSourceSubtitle>
                            {
                                    "Select source:"
                            }
                        </PhoneSourceSubtitle>
                        
                        <PhoneSelect 
                            phones={websitesArray}                                
                            selectedPhone={live?.urlWebsiteType}                                
                            displayAll={true}
                            onPhoneSelected={(value) => {
                                if (live)
                                    dispatch(editLiveDealerLMInfo({ ...live, urlWebsite: value.number,urlWebsiteType:value.source }))                                    
                            }}

                        />                            
                    

                    </>
                    :
                    <PhoneContainer>
                        <ViewLabelUrl>{url}</ViewLabelUrl>
                        <PhoneSource>
                            {" Source: " + (live?.urlWebsiteType==="GMB"?"GBP":live?.urlWebsiteType??"")}
                        </PhoneSource>
                    </PhoneContainer>                   
                  
            }

        
        </UrlSectionContainer>

          
        )
    }

    function getCountryCode (name:string){
        if (countries)
        {
            let country = countries.find(f=>f.name == name)
            if (country)
                return country?.iso2
        }
        return "";
    }

    function getCountryName (code:string){
        if (countries)
        {
            let country = countries.find(f=>f.iso2 == code)
            if (country)
                return country?.name
        }
        return "";
    }

    function getStateCode (countrycode:string, name:string){
        if (countries)
        {
            let country = countries.find(f=>f.iso2 == countrycode)
            let state = country?.states.find(f=> f.name == name)
            if (state)
                return state?.state_code            
        }
        return "";
    }

    function getStateName (countrycode:string, code:string){
        if (countries)
        {
            let country = countries.find(f=>f.iso2 == countrycode)
            if (country)
            {
                let state = country?.states.find(f=> f.state_code == code)
                if (state)
                    return state?.name
            }
        }
        return "";
    }

    function renderAddress() {        
        const isEditing = editingFields.indexOf("address") !== -1;
        return (

            <UrlSectionContainer>
            {
                isEditing ?
                    <>
                        {
                            live?.addressType =="Custom" ?
                            <AddressCustomContainer>
                                <TextToolTip
                                        tip={live.address?live?.address.street:""}                                        
                                    >          
                                <AddressInput
                                    value={live.address?live?.address.street:""}                                
                                    onChange={(event) => onDealerAddressChange("street", event?.target?.value)}
                                    style={{
                                        padding: "10px",
                                        margin: "5px 0 5px 0px",
                                        width: '300px'
                                    }}
                                    placeholder={"Street name & Number"}
                                
                                />
                                                              
                                    </TextToolTip>
                                <AddressInput
                                    value={live.address?live?.address.city:""}                                
                                    onChange={(event) => onDealerAddressChange("city", event?.target?.value)}
                                    style={{
                                        padding: "10px",
                                        margin: "5px 0 5px 0px",
                                        width: '190px'
                                    }}
                                    placeholder={"City"}
                                />
                                <AddressInput
                                    value={live.address?live?.address.zipcode:""}
                                    onChange={(event) => onDealerAddressChange("zipcode", event?.target?.value)}
                                    style={{
                                        padding: "10px",
                                        margin: "5px 0 5px 10px",
                                        width: '100px'
                                    }}
                                    placeholder={"ZIP"}
                                />
                                <ComboBox
                                    id ="countries"
                                    placeholder='Country'
                                    options={countryArray??[]}
                                    position={"bottom"}
                                    disabled={false}
                                    required={false}    
                                    chooseOption={(id, value)=>{                                             
                                        onDealerAddressChange("country", getCountryCode(value))
                                    }}                       
                                    value={live.address?getCountryName(live.address.country):""}
                                    light={true}     
                                    shadow={false}                  
                                    containerStyle={{                                        
                                        padding: "5px 0 5px 0",
                                        width: "145px",
            
                                    }}          
                                    style={{
                                        fontFamily: "Rubik"
                                    }}           
                                ></ComboBox>
                                                   
                                <ComboBox
                                    id ="states"
                                    placeholder='Region'
                                    options={stateArray??[]}
                                    position={"bottom"}
                                    disabled={false}
                                    required={false}    
                                    chooseOption={(id, value)=>{               
                                        onDealerAddressChange("state", getStateCode(live.address.country,value))
                                    }}                       
                                    value={live.address?getStateName(live.address.country, live.address.state):""}
                                    light={true}     
                                    shadow={false}                  
                                    containerStyle={{                                        
                                        padding: "5px 0 5px 10px",
                                        width: "145px",
            
                                    }}                     
                                    style={{
                                        fontFamily: "Rubik"
                                    }}
                                ></ComboBox>
                                
                            </AddressCustomContainer>
                            :
                            <PhoneContainer> {
                                live?.address? <div>{live.address.street}<br/>{live.address.city},{live.address.state} {live.address.zipcode}</div>:``
                            }</PhoneContainer>
                        }
                         <PhoneSourceSubtitle>
                            {
                                    "Select source:"
                            }
                        </PhoneSourceSubtitle>
                        
                        <PhoneSelect 
                            phones={addressArray}                                
                            selectedPhone={live?.addressType}                                
                            displayAll={true}
                            onPhoneSelected={(value) => handleAddressTypeSelected(value.source)}
                        />                            
                    

                    </>
                    :
                    <PhoneContainer>
                        <PhoneNumber>
                        {
                            live?.address? <div>{live.address.street}<br/>{live.address.city},{live.address.state} {live.address.zipcode}</div>:``
                        }
                        </PhoneNumber>
                        <PhoneSource>
                            {" Source: " + (live?.addressType==="GMB"?"GBP":live?.addressType??"")}
                        </PhoneSource>
                    </PhoneContainer>                   
                  
            }

        
        </UrlSectionContainer>

          
        )
    }

    function renderBusinessName() {
        const isEditing = editingFields.indexOf('businessName') !== -1;        

        return (
            <PhoneMainContainer>
                {
                    isEditing ?
                        <>
                            {
                                live?.businessNameType =="Custom" ?
                                <InputPhone
                                style={{width: '284px'}}
                                    value={live?.businessName}
                                    onChange={(value) => onDealerInfoChange("businessName", value)}
                                    type={"1"}
                                />
                                :
                                <PhoneContainer> {live?.businessName}</PhoneContainer>
                            }
                             <PhoneSourceSubtitle>
                                {
                                        "Select source:"
                                }
                            </PhoneSourceSubtitle>
                            <PhoneSelect 
                                phones={namesArray}                                
                                selectedPhone={live?.businessNameType}                                
                                onPhoneSelected={(value) => {
                                    if (live)
                                        dispatch(editLiveDealerLMInfo({ ...live, businessName: value.number,businessNameType:value.source }))                                    
                                }}

                            />                            
                        

                        </>
                        :
                        <PhoneContainer>
                            <PhoneNumber>
                                {live?.businessName==""?"Empty phone number field.":live?.businessName}
                            </PhoneNumber>
                            <PhoneSource>
                                {" Source: " + (live?.businessNameType==="GMB"?"GBP":live?.businessNameType??"")}
                            </PhoneSource>
                        </PhoneContainer>
                      
                }

            
            </PhoneMainContainer>
        )
    }

    function renderPhone() {
        const isEditing = editingFields.indexOf('phone') !== -1;        
        return (
            <PhoneMainContainer>
                {
                    isEditing ?
                        <>
                            {
                                live?.phoneType =="Custom" ?
                                <InputPhone
                                style={{width: '284px'}}
                                    value={live?.phone}
                                    onChange={(value) => onDealerInfoChange("phone", value)}
                                    type={"1"}
                                />
                                :
                                <PhoneContainer> {live?.phone}</PhoneContainer>
                            }
                             <PhoneSourceSubtitle>
                                {
                                        "Select source:"
                                }
                            </PhoneSourceSubtitle>
                            <PhoneSelect 
                                phones={phoneArray}                                
                                selectedPhone={live?.phoneType}                                
                                onPhoneSelected={(value) => {
                                  //
                                    if (live)
                                        dispatch(editLiveDealerLMInfo({ ...live, phone: value.number, phoneType:value.source }))
                                    //onDealerInfoChange("phone", value.number); onDealerInfoChange("phoneType", value.source);
                                }}

                            />                            
                        

                        </>
                        :
                        <PhoneContainer>
                            <PhoneNumber>
                                {live?.phone==""?"Empty phone number field.":live?.phone}
                            </PhoneNumber>
                            <PhoneSource>
                                {" Source: " + (live?.phoneType==="GMB"?"GBP":live?.phoneType??"")}
                            </PhoneSource>
                        </PhoneContainer>
                      
                }

            
            </PhoneMainContainer>
        )
    }

    function formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return match[1] + '-' + match[2] + '-' + match[3];
        }
        return null;
    }

    function onPhoneCheckboxClick() {
        if (live?.isPhoneDefaultFromCMS) {
            dispatch(editLiveDealerLMInfo({ ...live, isPhoneDefaultFromCMS: false }))
            setEditingFields(["phone"])
        } else if (live) {
            const cmsPhone = cmsInfo?.phone ?? ""
            dispatch(editLiveDealerLMInfo({ ...live, phone: cmsPhone, isPhoneDefaultFromCMS: true }))
        }
    }

    function getCharacterCount(field: string):number {
        if (live && live[field]) {
            return live[field].toString().length;
        }
        return 0;
    }

    function onDealerInfoChange(field: string, value: string) {
        if (live) {
            dispatch(editLiveDealerLMInfo({ ...live, [field]: value ?? "" }))
        }
    }

    function onDealerAddressChange(field: string, value: string) {
        if (live) {

            live.address[field] = value??"";
            dispatch(editLiveDealerLMInfo({ ...live, address: live.address}))
        }
    }

    function  handleAddressTypeSelected(type:string){     
        if (live)
        {            
            let newAddress = live.address
            if (!newAddress)
            {
                newAddress ={
                    city :"",
                    street :"",
                    zipcode :"",
                    state : "",
                    country: ""
                };
            }
            if (type=="CMS")
            {
                newAddress = {
                    city : cmsInfo?.city?cmsInfo?.city.toString():"",
                    street : cmsInfo?.adress??"",
                    zipcode : cmsInfo?.zipcode??"",
                    state : cmsInfo?.state?cmsInfo.state.toString():"",
                    country: countryData?countryData?.countryCode:""
                }                               
               
            }
            if (type=="GBP")
            {
                newAddress = {
                    city : cityGBP??"",
                    street : streetGBP??"",
                    zipcode :zipcodeGBP??"",
                    state : stateGBP??"",
                    country: countryGBP??""
                }               
            }
            

            dispatch(editLiveDealerLMInfo({ ...live, address:newAddress,addressType:type }))         
        }
    }


    function clearValidationError(field: string)
    {
        if(field=='urlAppointment' && validation && validation.dataValidation && validation.dataValidation.appointmentUrlError && validation.dataValidation.appointmentUrlError!="")
        {
            validation.dataValidation.appointmentUrlError="";
        }
        if(field=='urlMenu' && validation && validation.dataValidation && validation.dataValidation.menuUrlError && validation.dataValidation.menuUrlError!="")
        {
            validation.dataValidation.menuUrlError="";
        }
        if(field=='urlOrder' && validation && validation.dataValidation && validation.dataValidation.placeOrderLinkError && validation.dataValidation.placeOrderLinkError!="")
        {
            validation.dataValidation.placeOrderLinkError="";
        }
        if(field=='urlWebsite' && validation && validation.dataValidation && validation.dataValidation.websiteUrlError && validation.dataValidation.websiteUrlError!="")
        {
            validation.dataValidation.websiteUrlError="";
        }
    }

    function onFieldActionClick(action: InputIconFieldAction, field: string) {
        switch (action) {
            case InputIconFieldAction.EDIT: {
                setEditingFields([...editingFields, field]);
                break;
            }
            case InputIconFieldAction.SAVE: {
                if (live && originalLMDealerInfo) {
                    let liveDelta: Partial<LMconfig> = {};
                    if (field === "phone") {
                        liveDelta = {
                            isPhoneDefaultFromCMS: live.isPhoneDefaultFromCMS,
                            phoneType: live.phoneType
                        }
                    }
                    if (field === "businessName") {
                        liveDelta = {
                            businessNameType: live.businessNameType                                                        
                        }
                    }
                    if (field === "urlWebsite") {
                        liveDelta = {
                            urlWebsiteType: live.urlWebsiteType
                        }
                    }
                    if (field === "address") {
                        liveDelta = {
                            addressType: live.addressType
                        }
                    }
                    const editedLMConfig = {
                        ...originalLMDealerInfo,
                        [field]: live[field],
                        ...liveDelta
                    }
                    dispatch(postDealerLMAPI(selectedListingId ?? "", field, editedLMConfig))
                }
                setEditingFields(editingFields.filter(s => s !== field))
                break;
            }
            case InputIconFieldAction.CANCEL: {
                clearValidationError(field);
                setEditingFields(editingFields.filter(s => s !== field))
                if (live && originalLMDealerInfo) {
                    let ogDelta: Partial<LMconfig> = {};
                    if (field === "phone") {
                        ogDelta = {
                            isPhoneDefaultFromCMS: originalLMDealerInfo.isPhoneDefaultFromCMS,
                            phoneType: originalLMDealerInfo.phoneType
                        }
                    }
                    if (field === "businessName") {
                        ogDelta = {                            
                            businessNameType: originalLMDealerInfo.businessNameType
                        }
                    }
                    if (field === "urlWebsite") {
                        ogDelta = {                            
                            urlWebsiteType: originalLMDealerInfo.urlWebsiteType
                        }
                    }
                    const editedLive = {
                        ...live,
                        [field]: originalLMDealerInfo ? originalLMDealerInfo[field] : "",
                        ...ogDelta
                    }
                    dispatch(editLiveDealerLMInfo(editedLive))
                }
                break;
            }
        }
    }



}


export default DealerLM